module.exports = __webpack_public_path__ + "static/media/option.a549b353.svg";